import Eyebrow from "@/components/Eyebrow";
import { usePageMeta } from "@/lib/site";

export default function Cookies() {
  usePageMeta("Cookies — G&G accounting", "Zásady používání souborů cookies na webu G&G accounting.");
  return (
    <article className="px-6 md:px-12 py-20 md:py-28 bg-white">
      <div className="max-w-3xl mx-auto prose-content">
        <Eyebrow>Cookies</Eyebrow>
        <h1 className="font-display text-4xl md:text-6xl tracking-tighter font-medium mt-6 leading-[1.05]">
          Zásady cookies
        </h1>
        <div className="mt-10 space-y-6 text-base md:text-lg text-muted2 leading-relaxed">
          <p>
            Tento web používá pouze nezbytně nutné soubory cookies, bez kterých nemůže správně
            fungovat (např. uchování stavu souhlasu s cookies). Volitelně používáme analytické
            cookies pro měření návštěvnosti a zlepšování obsahu.
          </p>
          <h2 className="font-display text-2xl text-ink font-medium tracking-tight pt-4">Druhy cookies</h2>
          <ul className="list-disc pl-6 space-y-2">
            <li>
              <strong className="text-ink">Nezbytné cookies</strong> — zajišťují základní funkčnost
              webu (např. cookie banner, navigace). Nelze je vypnout.
            </li>
            <li>
              <strong className="text-ink">Analytické cookies</strong> — pomáhají nám pochopit, jak
              návštěvníci web používají. Aktivují se pouze s vaším souhlasem.
            </li>
          </ul>
          <h2 className="font-display text-2xl text-ink font-medium tracking-tight pt-4">Správa souhlasu</h2>
          <p>
            Souhlas s analytickými cookies můžete kdykoliv odvolat — vymazáním uložených dat ve vašem
            prohlížeči, nebo nás kontaktujte na e-mailu uvedeném v sekci Kontakt.
          </p>
        </div>
      </div>
    </article>
  );
}
